<div class="swiper-box swiper-full-wide" wmAnimate="fadeIn" #swiperAnimationIn aos once speed="faster">
    <!-- <div class="swiper-footer">
        <div class="swiper-pagination"></div>
    </div> -->
    <swiper [config]="config">
        <div class="swiper-slide small-swiper-slide" *ngFor="let item of listadoItems" wmAnimate="pulse" speed="superFaster" aos once>
            <div class="slide-large-image">
                <img src="{{ item.mobile }}" alt="" *ngIf="mobile">
                <img src="{{ item.desktop }}" alt="" *ngIf="!mobile">
            </div>
        </div>
    </swiper>
    <!-- <div class="swiper-full-wide-prev swiper-custom-arrow"></div>
    <div class="swiper-full-wide-next swiper-custom-arrow"></div> -->
    <div class="clearfix"></div>
</div>